import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMainArticlesLoading, EGetMainArticlesActionType } from './types';

export const getMainArticlesLoading: () => TGetMainArticlesLoading =
  actionGenerator<EGetMainArticlesActionType.Loading>(EGetMainArticlesActionType.Loading);
